import { reactive, computed } from '@vue/composition-api'

export const getPagenation = (props, context) => {

  const pageNation = reactive({

    // propsから取得した場合reactiveな値とならない
    count: computed(() => props.count),
    per_page: computed(() => props.per_page),
    currentPage: computed({
      get: () => {
        return props.currentPage
      },
      set: (num) => {
        const start = num * pageNation.per_page - pageNation.per_page
        context.emit('changePage', {
          currentPage: num,
          start: start
        })
      }
    }),
    firstPage: 1,
    endPage: computed(() => Math.ceil(pageNation.count / pageNation.per_page)),
    showNumber: computed(() => {
      const aryNum = (props.leftPage + props.rightPage + 1) > pageNation.endPage
        ? pageNation.endPage
        : props.leftPage + props.rightPage + 1
      const currentLeft = pageNation.currentPage - props.leftPage
      const maxExceed = pageNation.currentPage + props.rightPage - pageNation.endPage
      const tmpMinNumber = (currentLeft >= pageNation.firstPage)
        ? (maxExceed > 0) 
          ? currentLeft - maxExceed
          : currentLeft
        : pageNation.firstPage
      const minNumber = tmpMinNumber > 0 ? tmpMinNumber : pageNation.firstPage
      return [...Array(aryNum)].map((_, i) => i + minNumber)
    }),
    isFirst: computed(() => (pageNation.currentPage <= pageNation.firstPage)),
    isEnd: computed(() => (pageNation.currentPage >= pageNation.endPage)),
    clickPrev: () => {
      if (!pageNation.isFirst) {
        pageNation.currentPage--
      }
    },
    clickNext: () => {
      if (!pageNation.isEnd) {
        pageNation.currentPage++
      }
    },
    clickFirst: () => {
      if (pageNation.currentPage !== pageNation.firstPage) {
        pageNation.currentPage = pageNation.firstPage
      }
    },
    clickEnd: () => {
      if (pageNation.currentPage !== pageNation.endPage) {
        pageNation.currentPage = pageNation.endPage
      }
    },

    // ページを選択した場合(PCのみ使用。SPはpageNation.currentPageの値はリアクティブ変化する)
    clickPage: (page) => {
      pageNation.currentPage = page
    }
  })

  return pageNation
}
